import {
  TRANSACTION_HISTORY_BY_STUDENT_FORM_NAME,
  TRANSACTION_HISTORY_FORM_NAME,
  TRANSACTION_HISTORY_BY_DATE_FORM_NAME,
} from 'Common/FormEnum';

export const TransactionType = {
  Item: 'item',
  Student: 'student',
  Date: 'date',
};

export const FormNameByTransactionType = {
  [TransactionType.Student]: TRANSACTION_HISTORY_BY_STUDENT_FORM_NAME,
  [TransactionType.Item]: TRANSACTION_HISTORY_FORM_NAME,
  [TransactionType.Date]: TRANSACTION_HISTORY_BY_DATE_FORM_NAME,
};



// WEBPACK FOOTER //
// ./src/pages/transactionhistory/constants/index.js